import React from 'react';
import { ArrowRight } from 'lucide-react';

interface SummarySelectProps {
  title: string;
  conclusion: string;
  details?: string;
  selected?: boolean;
  onSelectChange?: (checked: boolean) => void;
  variant?: 'lightPurple' | 'green' | 'blue';
  className?: string;
}

const SummarySelect: React.FC<SummarySelectProps> = ({
  title,
  conclusion,
  details,
  selected = true,
  onSelectChange,
  variant = 'lightPurple',
  className = 'mb-3'
}) => {
  // 根据变体选择不同的样式
  const getVariantStyles = () => {
    switch (variant) {
      case 'green':
        return {
          container: 'bg-[linear-gradient(180deg,#EBFDFA_0%,#F3FFFD_100%)]',
          detailsBg: 'bg-[#D2F0EB]'
        };
      case 'blue':
        return {
          container: 'bg-gradient-to-br from-blue-50 to-indigo-50',
          detailsBg: 'bg-blue-100/40'
        };
      default: // purple
        return {
          container: 'bg-[linear-gradient(267deg,#EEEDFF_4.19%,#F6F7FF_86.14%)]',
          detailsBg: 'bg-[rgba(202,208,251,0.4)]'
        };
    }
  };

  const styles = getVariantStyles();

  return (
    <div
      className={`${styles.container} border-gradient-to-r rounded-lg border from-purple-200 to-pink-200 p-3 shadow-inner ${className}`}
    >
      {/* 标题行 */}
      <div className="mb-1.5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={selected}
            onChange={e => onSelectChange?.(e.target.checked)}
            className="h-4 w-4 rounded border border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-base font-semibold text-gray-900">{title}</span>
        </div>
        <div>
          <ArrowRight size={16} />
        </div>
      </div>

      {/* 结论与建议 */}
      <p className="mb-1.5 text-xs leading-relaxed text-gray-900">{conclusion}</p>

      {/* 详细信息 */}
      {details && (
        <div className={`${styles.detailsBg} rounded-md p-1`}>
          <p className="whitespace-pre-line px-2 text-xs leading-relaxed text-gray-900">
            {details}
          </p>
        </div>
      )}
    </div>
  );
};

export default SummarySelect;
